"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ListIcon;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("./shared/icon-base"));
var _core = require("@emotion/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ListIcon(props) {
  return (0, _core.jsx)(_iconBase.default, props, (0, _core.jsx)("path", {
    d: "M5.66821 6.01404C5.66821 6.97321 5.03186 7.75 4.00244 7.75C2.97302 7.75 2.33203 6.97321 2.33203 6.01404C2.33203 5.02667 2.97302 4.25 4.00244 4.25C5.03186 4.25 5.66821 5.02667 5.66821 6.01404ZM4.00244 10.25C2.97302 10.25 2.33203 11.0267 2.33203 12.014C2.33203 12.9732 2.97302 13.75 4.00244 13.75C5.03186 13.75 5.66821 12.9732 5.66821 12.014C5.66821 11.0267 5.03186 10.25 4.00244 10.25ZM4.00244 16.25C2.97302 16.25 2.33203 17.0267 2.33203 18.014C2.33203 18.9732 2.97302 19.75 4.00244 19.75C5.03186 19.75 5.66821 18.9732 5.66821 18.014C5.66821 17.0267 5.03186 16.25 4.00244 16.25ZM8.00012 5V7H22.0001V5H8.00012ZM19.0001 11H8.00012V13H19.0001V11ZM8.00012 19H22.0001V17H8.00012V19Z",
    fill: "currentColor"
  }));
}